/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Invite_X15_SentInputs */

const en_invite_x15_sent = /** @type {(inputs: Invite_X15_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We sent a sign-in link to ${i?.email}. Open it in this browser to finish joining.`)
};

/** @type {(inputs: Invite_X15_SentInputs) => LocalizedString} */
const ar_invite_x15_sent = en_invite_x15_sent;

/** @type {(inputs: Invite_X15_SentInputs) => LocalizedString} */
const he_invite_x15_sent = en_invite_x15_sent;

/** @type {(inputs: Invite_X15_SentInputs) => LocalizedString} */
const ur_invite_x15_sent = en_invite_x15_sent;

/** @type {(inputs: Invite_X15_SentInputs) => LocalizedString} */
const es_invite_x15_sent = en_invite_x15_sent;

/** @type {(inputs: Invite_X15_SentInputs) => LocalizedString} */
const fr_invite_x15_sent = en_invite_x15_sent;

/** @type {(inputs: Invite_X15_SentInputs) => LocalizedString} */
const de_invite_x15_sent = en_invite_x15_sent;

/** @type {(inputs: Invite_X15_SentInputs) => LocalizedString} */
const pt_invite_x15_sent = en_invite_x15_sent;

/** @type {(inputs: Invite_X15_SentInputs) => LocalizedString} */
const hi_invite_x15_sent = en_invite_x15_sent;

/** @type {(inputs: Invite_X15_SentInputs) => LocalizedString} */
const bn_invite_x15_sent = en_invite_x15_sent;

/**
* | output |
* | --- |
* | "We sent a sign-in link to {email}. Open it in this browser to finish joining." |
*
* @param {Invite_X15_SentInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_x15_sent = /** @type {((inputs: Invite_X15_SentInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_SentInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_x15_sent(inputs)
	if (locale === "he") return he_invite_x15_sent(inputs)
	if (locale === "ur") return ur_invite_x15_sent(inputs)
	if (locale === "es") return es_invite_x15_sent(inputs)
	if (locale === "fr") return fr_invite_x15_sent(inputs)
	if (locale === "de") return de_invite_x15_sent(inputs)
	if (locale === "pt") return pt_invite_x15_sent(inputs)
	if (locale === "hi") return hi_invite_x15_sent(inputs)
	if (locale === "bn") return bn_invite_x15_sent(inputs)
	return en_invite_x15_sent(inputs)
});